import { styled } from '@mui/material/styles';
import Popover, { popoverClasses } from '@mui/material/Popover';

// we should reduce the container size because the anchor has an almost invisible border
// so it might seem like the container is bigger than the anchor.
const anchorBorderSize = 2;

const getMenuWidth = (theme, size, containerWidth) => {
  const isFullWidth = size === 'fullWidth' && containerWidth;

  if (isFullWidth) {
    return {
      width: containerWidth - anchorBorderSize
    };
  }

  return {
    minWidth: theme.sizes?.multiSelectMenu[size] - anchorBorderSize
  };
};
export const MultiSelectMenuRoot = styled(Popover, {
  name: 'AFMultiSelectMenu'
})({
  [`& .${popoverClasses.paper}`]: {
    display: 'flex'
  }
});

export const MultiSelectMenuContent = styled('div', {
  shouldForwardProp: prop => prop !== 'size' && prop !== 'width'
})(({ theme, size, width }) => ({
  ...getMenuWidth(theme, size, width)
}));
